var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 12,
    viewBox: "0 0 21 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xF0\x9F\xA6\x86 icon \"link\""
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.3997 6.25247C12.3997 8.61949 10.1986 11 7.5141 11C7.19611 11 6.14794 11 5.88558 11C3.18735 11 1 8.87444 1 6.25247C1 3.99308 2.6242 2.10227 4.79989 1.62254C5.14906 1.5455 5.51243 1.50494 5.88558 1.50494",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.60059 6.25246C8.60059 3.88544 10.8017 1.50493 13.4862 1.50493C13.8042 1.50493 14.8524 1.50493 15.1146 1.50493C17.8129 1.50493 20.0003 3.63047 20.0003 6.25246C20.0003 8.51185 18.3761 10.4026 16.2004 10.8824C15.8512 10.9594 15.4878 11 15.1146 11",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.cdc3229bcfb08d668e3d69eac0c3bd4f.svg";
export { ForwardRef as ReactComponent };